var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_2",
    d: "m59,16l0,-14l-58,0l0,14l-1,0l0,37.259c0,2.614 2.127,4.741 4.742,4.741l50.517,0c2.614,0 4.741,-2.127 4.741,-4.741l0,-37.259l-1,0zm-2.5,0l-5.18,-6.906l5.094,-5.094l0.586,0l0,12l-0.5,0zm-45.5,0l0,-7c0,-0.024 -0.012,-0.046 -0.014,-0.07c-0.005,-0.064 -0.02,-0.124 -0.036,-0.187c-0.011,-0.042 -0.01,-0.085 -0.027,-0.125c-0.009,-0.022 -0.027,-0.039 -0.037,-0.061c-0.027,-0.055 -0.065,-0.102 -0.103,-0.152c-0.028,-0.036 -0.044,-0.081 -0.077,-0.113l-4.292,-4.292l47.172,0l-4.292,4.292c-0.032,0.032 -0.049,0.077 -0.077,0.113c-0.038,0.05 -0.075,0.097 -0.102,0.152c-0.011,0.022 -0.028,0.038 -0.038,0.061c-0.017,0.04 -0.016,0.084 -0.027,0.125c-0.017,0.063 -0.032,0.122 -0.036,0.187c-0.002,0.024 -0.014,0.046 -0.014,0.07l0,7l-38,0zm-5,0l3,-4.001l0,4.001l-3,0zm45,-4.001l3,4.001l-3,0l0,-4.001zm-48,-7.999l0.586,0l5.094,5.094l-5.18,6.906l-0.5,0l0,-12zm55,49.259c0,1.512 -1.23,2.741 -2.742,2.741l-50.516,0c-1.512,0 -2.742,-1.229 -2.742,-2.741l0,-35.259l56,0l0,35.259z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_3",
    d: "m42,24c-0.552,0 -1,0.447 -1,1l0,6c0,6.065 -4.935,11 -11,11s-11,-4.935 -11,-11l0,-6c0,-0.553 -0.448,-1 -1,-1s-1,0.447 -1,1l0,6c0,7.168 5.832,13 13,13s13,-5.832 13,-13l0,-6c0,-0.553 -0.448,-1 -1,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_4",
    d: "m20,25c0,0.553 0.448,1 1,1s1,-0.447 1,-1c0,-2.206 -1.794,-4 -4,-4s-4,1.794 -4,4c0,0.553 0.448,1 1,1s1,-0.447 1,-1c0,-1.103 0.897,-2 2,-2s2,0.897 2,2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_5",
    d: "m42,21c-2.206,0 -4,1.794 -4,4c0,0.553 0.448,1 1,1s1,-0.447 1,-1c0,-1.103 0.897,-2 2,-2s2,0.897 2,2c0,0.553 0.448,1 1,1s1,-0.447 1,-1c0,-2.206 -1.794,-4 -4,-4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/bag-icon.1d84abb515c285341cdf05373ed63564.svg";
export { ForwardRef as ReactComponent };